import React from "react";
import $ from "jquery";
import Auth from "j-toker";
import globals from "../globals";
import { readAPIErrorMessage } from "../helper/api_helper";
export function setUserLocalStorage() {
  // Get from storage or from request
  if (localStorage.getItem("user")) {
    if (localStorage.getItem("user") === "undefined") {
      return {
        signedIn: false
      };
    }
    const user = JSON.parse(localStorage.getItem("user"));
    return {
      signedIn: true,
      user: user,
      loaded: true
    };
  } else {
    return {
      signedIn: false
    };
  }
}

export function getUser() {
  let hasCanceled_ = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    $.get(globals.baseAPI + "me", function(res) {
      localStorage.setItem("user", JSON.stringify(res.user));
      if (!hasCanceled_) {
        resolve({
          signedIn: true,
          user: res.user,
          loaded: true
        });
      }
    }).fail(function(err) {
      // Logout User if fail get me
      logout();
      if (!hasCanceled_) {
        resolve({
          signedIn: false,
          loaded: true,
          user: null
        });
      }
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}

export function updateUser(userfd) {
  let hasCanceled_ = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: globals.baseAPI + "me",
      type: "PUT",
      data: userfd,
      success: function(res) {
        if (!hasCanceled_) {
          resolve({
            user: res.user,
            errors: "",
            loaded: true
          });
        }
      },
      error: function(err) {
        if (!hasCanceled_) {
          reject({
            user: null,
            errors: readAPIErrorMessage(err),
            loaded: true
          });
        }
      },
      contentType: false,
      processData: false
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}

export function getUserId(userName) {
  let hasCanceled_ = false;
  var ajaxCall = null;
  const wrappedPromise = new Promise((resolve, reject) => {
    ajaxCall = $.get(globals.baseAPI + "users/" + userName, function(res) {
      if (!hasCanceled_) {
        resolve({
          user: res.user,
          loaded: true,
          errors: ""
        });
      }
    }).fail(function(err) {
      if (!hasCanceled_) {
        resolve({
          loaded: true,
          user: null,
          errors: readAPIErrorMessage(err)
        });
      }
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
      ajaxCall.abort();
    }
  };
}

export function userQuestions(userName, page) {
  let hasCanceled_ = false;
  var ajaxCall = null;
  const wrappedPromise = new Promise((resolve, reject) => {
    ajaxCall = $.get(
      globals.baseAPI + "users/" + userName + "/questions?page=" + page,
      function(res) {
        if (!hasCanceled_) {
          resolve({
            questions: res.questions,
            loaded: true,
            total_pages: res.total_page
          });
        }
      }
    ).fail(function(err) {
      if (!hasCanceled_) {
        reject({ errors: readAPIErrorMessage(err) });
      }
    });
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
      ajaxCall.abort();
    }
  };
}

export function userAnswers(userName, page) {
  let hasCanceled_ = false;
  var ajaxCall = null;
  const wrappedPromise = new Promise((resolve, reject) => {
    ajaxCall = $.get(
      globals.baseAPI + "users/" + userName + "/answers?page=" + page,
      function(res) {
        if (!hasCanceled_) {
          resolve({
            answers: res.answers,
            loaded: true,
            total_pages: res.total_page
          });
        }
      }
    ).fail(function(err) {
      if (!hasCanceled_) {
        reject({ errors: readAPIErrorMessage(err) });
      }
    });
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
      ajaxCall.abort();
    }
  };
}

export function userRecommendations(userName, page) {
  let hasCanceled_ = false;
  var ajaxCall = null;
  const wrappedPromise = new Promise((resolve, reject) => {
    ajaxCall = $.get(
      globals.baseAPI + "users/" + userName + "/recommendations?page=" + page,
      function(res) {
        if (!hasCanceled_) {
          resolve({
            recommendations: res.recommendations,
            loaded: true,
            total_pages: res.total_page
          });
        }
      }
    ).fail(function(err) {
      if (!hasCanceled_) {
        reject({ errors: readAPIErrorMessage(err) });
      }
    });
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
      ajaxCall.abort();
    }
  };
}

export function userHashtags(userName, page) {
  let hasCanceled_ = false;
  var ajaxCall = null;
  const wrappedPromise = new Promise((resolve, reject) => {
    ajaxCall = $.get(
      globals.baseAPI + "users/" + userName + "/hashtags?page=" + page,
      function(res) {
        if (!hasCanceled_) {
          resolve({
            hashtags_selected: res.hashtags_selected,
            hashtags: res.hashtags,
            loaded: true,
            total_pages: res.total_page
          });
        }
      }
    ).fail(function(err) {
      if (!hasCanceled_) {
        reject({ errors: readAPIErrorMessage(err) });
      }
    });
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
      ajaxCall.abort();
    }
  };
}

export function checkUsername(userName, phone_number_) {
  let phone_number = phone_number_.replace(/\s/g, "");
  let hasCanceled_ = false;
  var ajaxCall = null;
  const wrappedPromise = new Promise((resolve, reject) => {
    ajaxCall = $.get(
      globals.baseAPI +
        "users/valid_username?username=" +
        userName +
        "&phone_number=" +
        phone_number,
      function(res) {
        if (!hasCanceled_) {
          resolve({
            hashtags: res.hashtags,
            loaded: true,
            total_pages: res.total_page
          });
        }
      }
    ).fail(function(err) {
      if (!hasCanceled_) {
        reject({ errors: readAPIErrorMessage(err) });
      }
    });
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
      ajaxCall.abort();
    }
  };
}

export function userLikes(userName, page) {
  let hasCanceled_ = false;
  var ajaxCall = null;
  const wrappedPromise = new Promise((resolve, reject) => {
    ajaxCall = $.get(
      globals.baseAPI + "users/" + userName + "/likes?page=" + page,
      function(res) {
        if (!hasCanceled_) {
          resolve({
            recommendations: res.recommendations,
            loaded: true,
            total_pages: res.total_page
          });
        }
      }
    ).fail(function(err) {
      if (!hasCanceled_) {
        reject({ errors: readAPIErrorMessage(err) });
      }
    });
  });
  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
      ajaxCall.abort();
    }
  };
}

export function logout() {
  localStorage.removeItem("user");
  Auth.signOut();
}

export function renderErrorMessage(errors) {
  if (!errors) return <div />;
  if (errors === "") return <div />;
  return (
    <div className="center">
      <label className="alert alert-danger block mb-3 mt-3">{errors}</label>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/helper/user_helper.jsx